import { render, staticRenderFns } from "./PreviewPageHeader.vue?vue&type=template&id=86798ede&scoped=true&"
import script from "./PreviewPageHeader.vue?vue&type=script&lang=js&"
export * from "./PreviewPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPageHeader.vue?vue&type=style&index=0&id=86798ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86798ede",
  null
  
)

export default component.exports